const CERTAINTY_TYPE = {
  NO_CURATION_DATA: 'No Curation Data',
  LOW: 'Low',
  HIGH: 'High',
}

export default CERTAINTY_TYPE
